import { render, staticRenderFns } from "./NavRoute.vue?vue&type=template&id=9bbb1f06&scoped=true&"
import script from "./NavRoute.vue?vue&type=script&lang=js&"
export * from "./NavRoute.vue?vue&type=script&lang=js&"
import style0 from "./NavRoute.vue?vue&type=style&index=0&id=9bbb1f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbb1f06",
  null
  
)

export default component.exports